import {createAsyncThunk} from "@reduxjs/toolkit";
import {HOSTNAME} from "../configs/Domain";

export const listNewsKeywords = createAsyncThunk(
  'news/fetchNewsKeywordsIfNeeded',
  async (_, { getState, dispatch, rejectWithValue }) => {
    const state = getState();

    // Check if keywords are already fetched
    if (state.news.hasFetchedKeywords) {
      return null; // No need to fetch again
    }

    try {
      const response = await fetch(`${HOSTNAME}/news/list/keywords`);
      if (!response.ok) throw new Error('Network response was not ok');

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchSiteNews = createAsyncThunk(
  'news/fetchSiteNews',
  async (_, { getState, rejectWithValue }) => {
    const state = getState();
    const page = state.news.sitePageIndex;

    try {
      // Using default sites from backend, no need to specify sites parameter
      const response = await fetch(
        `${HOSTNAME}/news/search/sites?page=${page}&limit=25`
      );

      if (!response.ok) throw new Error('Network response was not ok');

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);